const CONTACT_VALIDATION_TYPES = {
  ADDRESS: 'address',
  BUSINESS: 'business',
} as const;

export default CONTACT_VALIDATION_TYPES;
